import { Component, Inject } from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { ProductReleaseStatus } from "../../interfaces/ProductReleaseStatusEnum.model";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { ProductReleaseService } from "../../services/ProductReleaseService";
import swal from "sweetalert2";

@Component({
  selector: "change-release-type",
  template: require('./change-release-type.component.html'),  
  styles: [require('./change-release-type.component.css')]
})
export class ChangeReleaseTypeComponent {

  selectedReleaseType: ProductReleaseStatus;
  currentReleaseBadge: string;
  ProductReleaseStatus = ProductReleaseStatus;
  isHigherProdReleaseExists: boolean;
  latestProdRelease: any;
  isQAEnabled: boolean = false;
  isNotifySyncItClientAdmin: any = null;
  releaseType: string;
  constructor(
    public dialogRef: MdDialogRef<ChangeReleaseTypeComponent>,
    private appLoaderService: AppLoaderService,
    public snackBar: MdSnackBar,
    private productRelaseService: ProductReleaseService,
    @Inject(MD_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    document.body.style.overflow="hidden";
    this.releaseType = this.data.Status == ProductReleaseStatus.PilotRelease ? "Pilot" : "Custom";
    console.log(this.data);
    this.currentReleaseBadge = `${this.releaseType} Release`;

    // check if prod release exists and is newer than the current release, if yes then disable the Prod option    
    const releaseList = this.data.releaseList || [];
    this.isQAEnabled = releaseList.some((release: any) =>
      release.IsDeleted == false && 
      release.Status === ProductReleaseStatus.ProductionRelease 
    );

    this.latestProdRelease = releaseList.find((release: any) => {
      return release.IsDeleted == false && release.Status === ProductReleaseStatus.ProductionRelease
    });

    console.log(this.latestProdRelease)

    this.isHigherProdReleaseExists = releaseList.some((release: any) =>
      release.Status === ProductReleaseStatus.ProductionRelease &&
      release.IsDeleted == false && 
      this.compareVersions(release.ProductReleaseNo, this.data.ProductReleaseNo) > 0
    );
  }

  private compareVersions(version1: string, version2: string): number {
    const versionRegex = /^\d+(\.\d+)*$/;

    // Ignore invalid version strings
    if (!versionRegex.test(version1) || !versionRegex.test(version2)) {
        return 0;
    }

    const v1 = version1.split('.').map(Number);
    const v2 = version2.split('.').map(Number);

    const maxLength = Math.max(v1.length, v2.length);

    for (let i = 0; i < maxLength; i++) {
      const num1 = v1[i] || 0;
      const num2 = v2[i] || 0;

      if (num1 > num2) return 1;
      if (num1 < num2) return -1;
    }

    return 0;
  }

  isConfirmButtonDisabled(){
    const disabled = (this.selectedReleaseType == null) || (this.isNotifySyncItClientAdmin == null && !this.isRadioGroupDisabled())
    return disabled;
  }

  isRadioGroupDisabled(): boolean {
    return this.selectedReleaseType === ProductReleaseStatus.QARelease && !this.isHigherProdReleaseExists;
  }

  getWarningMessage(){
    let message;
    if(this.selectedReleaseType == ProductReleaseStatus.ProductionRelease){
      const isCustomRelease = this.data.Status == ProductReleaseStatus.CustomRelease;

      const oppositeRelease = isCustomRelease ? "pilot" : "custom";
      const oppositeStatus = isCustomRelease
        ? ProductReleaseStatus.PilotRelease
        : ProductReleaseStatus.CustomRelease;

      const oppositeReleaseObj = this.data.releaseList.find(
        (release: any) =>
          !release.IsDeleted &&
          release.Status == oppositeStatus
      );

      if(oppositeReleaseObj){
        message = `Release v${this.data.ProductReleaseNo} will become available for all customers <b>except</b> those enrolled in ${oppositeRelease} release v${oppositeReleaseObj.ProductReleaseNo}.`
      }
      else{
        message = `Release v${this.data.ProductReleaseNo} will become available for all customers.`
      }

    }
    else{
      if(this.isHigherProdReleaseExists) message = `Enrolled customers will get the latest prod release v${this.latestProdRelease.ProductReleaseNo}.`;
      else message = `Enrolled customers will stay on v${this.data.ProductReleaseNo} until a new Prod release is available.`;
    }

    return message;
  }
  
  getCheckboxNote(){
    let message;
    if(this.isHigherProdReleaseExists)
      message = `<strong>Note:</strong> Only the admins of customers enrolled in this release will receive notification email for latest prod release v${this.latestProdRelease.ProductReleaseNo}.`
    else 
      message = `<strong>Note:</strong> Only the admins of customers enrolled in this release will receive notification email for latest prod release.`

    return message;
  }

  onReleaseTypeChanged(type: ProductReleaseStatus) {
    this.selectedReleaseType = type;

    if (type === ProductReleaseStatus.QARelease &&
        !this.isHigherProdReleaseExists) {
        this.isNotifySyncItClientAdmin = null;
    }
  }

  STPStart(showLoadder: boolean = true, ISRequestSTP = false) {
    if (showLoadder) this.appLoaderService.open();

    let model = {
      ProductReleaseId: this.data.ProductReleaseId,
      IsApproved: true,
      UpdatedBy: Number(localStorage.getItem("userid")),
    };

    this.productRelaseService.STPStart(model).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
            this.snackBar.open("STP Started", "", {
              duration: 2000,
            });
        } else {
            this.snackBar.open(data.Error, "", {
              duration: 2000,
            });
        }

        let result = {
          SelectedReleaseType: ProductReleaseStatus.STPStart,
        }
        document.body.style.overflow="auto";
        this.dialogRef.close(result);
      },
      (_error) => {
        document.body.style.overflow="auto";
        this.dialogRef.close(false);
        this.appLoaderService.close();
      }
    );
  }

  onConfirm() {
    if(this.selectedReleaseType == ProductReleaseStatus.ProductionRelease && !this.data.IsSTPPerformed){
      swal.fire({        
        title: "<strong>Releasing Product without STP</strong>",
        icon: "info",
        html: `
          <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>
          <b>Please confirm your action:</b>
          <ul style="text-align: left;">
          <li style="margin-top:10px;"><b>Accept:</b> Proceed with releasing this product without STP.</li>
          <li><b>Request STP:</b> Requesting QA Department to perform STP.</li>
          <li><b>Cancel:</b> Effectively closes this dialog box without applying any alterations.</li>
          </ul>`,
        showCloseButton: true,
        showCancelButton: true,
        showDenyButton: true,
        focusConfirm: false,
        confirmButtonText: `Accept`,
        confirmButtonAriaLabel: "Accept",
        cancelButtonText: `Cancel`,
        cancelButtonAriaLabel: "Cancel",
        denyButtonText: `Request STP`,
        denyButtonAriaLabel: "Request STP",
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.changeReleaseType();
        } else if (result.isDenied) {
          this.appLoaderService.open();
          this.productRelaseService
            .getReleaseByProductId(this.data.ProductId)
            .subscribe(
              (data) => {
                let IsAllowRelease: boolean = true;
                if (!data.IsError && data.DataObject != null) {
                  
                  let releaseData = data.DataObject;
                  releaseData.forEach((element) => {
                    if (
                      (element.Status == 0 || element.Status == 1) &&
                      element.IsDeleted == false
                    ) {
                      IsAllowRelease = false;
                    }
                  });
                  if (IsAllowRelease == true) {
                    this.STPStart(false, true);
                  } else {
                    this.appLoaderService.close();
                    swal.fire({
                      title: "<strong>Unable To Process Request</strong>",
                      icon: "info",
                      html: `<P>You can't request STP because there is already one pending release in queue</P>`,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: "Ok",
                    })
                    .then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        this.onConfirm();
                      }
                    });
                  }
                } else {
                  this.appLoaderService.close();
                }
              },
              (error) => {
                this.appLoaderService.close();
              }
            );
        }
      });
    }
    else{
      this.changeReleaseType();
    }
  }
 
  changeReleaseType() {
    console.log(`Selected Release Type: ${this.selectedReleaseType}, isNotifySyncItClientAdmin: ${this.isNotifySyncItClientAdmin}`);    
    const releaseTypeName = this.selectedReleaseType === ProductReleaseStatus.ProductionRelease ? "Prod" : "QA";
    this.appLoaderService.open();

    let model = {
      ProductId: Number(this.data.ProductId),
      ProductReleaseId: this.data.ProductReleaseId,
      ReleaseStatus: this.selectedReleaseType,
      UpdatedBy: Number(localStorage.getItem("userid")),
    };

    this.productRelaseService.ChangePilotCustomReleaseStatus(model).subscribe(
      (data) => {
        if(!data.IsError && data.DataObject != null){
          let releaseStatusChangeMessage =`Release status changed to ${releaseTypeName} Successfully`;
          this.dialogRef.close({
            SelectedReleaseType: this.selectedReleaseType,
            isNotifySyncItClientAdmin: this.isNotifySyncItClientAdmin,
            customers: data.DataObject.customerIds
          });        
          this.snackBar.open(releaseStatusChangeMessage, "", {
            duration: 2000,
          });
        }
        else{
          this.dialogRef.close(false);
          this.snackBar.open(data.Error, "", {
            duration: 2000,          
          });          
        }
        document.body.style.overflow="auto";
      },
      (error) => {
        document.body.style.overflow="auto";
        this.dialogRef.close(false);
      }
    )
  }
  
  onCancel() {
    document.body.style.overflow="auto";
    this.dialogRef.close(); 
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/change-release-type/change-release-type.component.ts